export type Theme = 'dark' | 'light';

export const DEFAULT_THEME: Theme = 'light';
export const THEME_STORAGE_KEY = 'tcgsecret-theme';

/**
 * Runs before the page paints. The CSS defaults to dark and html.light switches to the light colours,
 * so this adds the class straight away unless the visitor chose dark, and light never flashes dark.
 */
export const THEME_INIT_SCRIPT = `(function(){var t='${DEFAULT_THEME}';try{var s=localStorage.getItem('${THEME_STORAGE_KEY}');if(s==='light'||s==='dark')t=s}catch(e){}document.documentElement.classList.add(t)})();`;
